/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "onte",
        "-2": "antonte",
        "0": "hoxe",
        "1": "mañá",
        "2": "pasadomañá",
        "future": {
          "one": "en {0} día",
          "other": "en {0} días"
        },
        "past": {
          "one": "hai {0} día",
          "other": "hai {0} días"
        }
      },
      "day-narrow": {
        "-1": "onte",
        "-2": "antonte",
        "0": "hoxe",
        "1": "mañá",
        "2": "pasadomañá",
        "future": {
          "one": "en {0} día",
          "other": "en {0} días"
        },
        "past": {
          "one": "hai {0} día",
          "other": "hai {0} días"
        }
      },
      "day-short": {
        "-1": "onte",
        "-2": "antonte",
        "0": "hoxe",
        "1": "mañá",
        "2": "pasadomañá",
        "future": {
          "one": "en {0} día",
          "other": "en {0} días"
        },
        "past": {
          "one": "hai {0} día",
          "other": "hai {0} días"
        }
      },
      "hour": {
        "0": "esta hora",
        "future": {
          "one": "en {0} hora",
          "other": "en {0} horas"
        },
        "past": {
          "one": "hai {0} hora",
          "other": "hai {0} horas"
        }
      },
      "hour-narrow": {
        "0": "esta hora",
        "future": {
          "one": "en {0} h",
          "other": "en {0} h"
        },
        "past": {
          "one": "hai {0} h",
          "other": "hai {0} h"
        }
      },
      "hour-short": {
        "0": "esta hora",
        "future": {
          "one": "en {0} h",
          "other": "en {0} h"
        },
        "past": {
          "one": "hai {0} h",
          "other": "hai {0} h"
        }
      },
      "minute": {
        "0": "este minuto",
        "future": {
          "one": "en {0} minuto",
          "other": "en {0} minutos"
        },
        "past": {
          "one": "hai {0} minuto",
          "other": "hai {0} minutos"
        }
      },
      "minute-narrow": {
        "0": "este minuto",
        "future": {
          "one": "en {0} min",
          "other": "en {0} min"
        },
        "past": {
          "one": "hai {0} min",
          "other": "hai {0} min"
        }
      },
      "minute-short": {
        "0": "este minuto",
        "future": {
          "one": "en {0} min",
          "other": "en {0} min"
        },
        "past": {
          "one": "hai {0} min",
          "other": "hai {0} min"
        }
      },
      "month": {
        "-1": "o mes pasado",
        "0": "este mes",
        "1": "o próximo mes",
        "future": {
          "one": "en {0} mes",
          "other": "en {0} meses"
        },
        "past": {
          "one": "hai {0} mes",
          "other": "hai {0} meses"
        }
      },
      "month-narrow": {
        "-1": "o mes pas.",
        "0": "este mes",
        "1": "o próx. mes",
        "future": {
          "one": "en {0} mes",
          "other": "en {0} meses"
        },
        "past": {
          "one": "hai {0} mes",
          "other": "hai {0} meses"
        }
      },
      "month-short": {
        "-1": "o mes pasado",
        "0": "este mes",
        "1": "o próximo mes",
        "future": {
          "one": "en {0} mes",
          "other": "en {0} meses"
        },
        "past": {
          "one": "hai {0} mes",
          "other": "hai {0} meses"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "o trimestre pasado",
        "0": "este trimestre",
        "1": "o próximo trimestre",
        "future": {
          "one": "en {0} trimestre",
          "other": "en {0} trimestres"
        },
        "past": {
          "one": "hai {0} trimestre",
          "other": "hai {0} trimestres"
        }
      },
      "quarter-narrow": {
        "-1": "trim. pasado",
        "0": "este trim.",
        "1": "trim. seguinte",
        "future": {
          "one": "en {0} trim.",
          "other": "en {0} trim."
        },
        "past": {
          "one": "hai {0} trim.",
          "other": "hai {0} trim."
        }
      },
      "quarter-short": {
        "-1": "trim. pasado",
        "0": "este trim.",
        "1": "trim. seguinte",
        "future": {
          "one": "en {0} trim.",
          "other": "en {0} trim."
        },
        "past": {
          "one": "hai {0} trim.",
          "other": "hai {0} trim."
        }
      },
      "second": {
        "0": "agora",
        "future": {
          "one": "en {0} segundo",
          "other": "en {0} segundos"
        },
        "past": {
          "one": "hai {0} segundo",
          "other": "hai {0} segundos"
        }
      },
      "second-narrow": {
        "0": "agora",
        "future": {
          "one": "en {0} s",
          "other": "en {0} s"
        },
        "past": {
          "one": "hai {0} s",
          "other": "hai {0} s"
        }
      },
      "second-short": {
        "0": "agora",
        "future": {
          "one": "en {0} s",
          "other": "en {0} s"
        },
        "past": {
          "one": "hai {0} s",
          "other": "hai {0} s"
        }
      },
      "week": {
        "-1": "a semana pasada",
        "0": "esta semana",
        "1": "a próxima semana",
        "future": {
          "one": "en {0} semana",
          "other": "en {0} semanas"
        },
        "past": {
          "one": "hai {0} semana",
          "other": "hai {0} semanas"
        }
      },
      "week-narrow": {
        "-1": "a sem. pas.",
        "0": "esta sem.",
        "1": "a próx. sem.",
        "future": {
          "one": "en {0} sem.",
          "other": "en {0} sem."
        },
        "past": {
          "one": "hai {0} sem.",
          "other": "hai {0} sem."
        }
      },
      "week-short": {
        "-1": "a sem. pasada",
        "0": "esta sem.",
        "1": "a próxima sem.",
        "future": {
          "one": "en {0} sem.",
          "other": "en {0} sem."
        },
        "past": {
          "one": "hai {0} sem.",
          "other": "hai {0} sem."
        }
      },
      "year": {
        "-1": "o ano pasado",
        "0": "este ano",
        "1": "o próximo ano",
        "future": {
          "one": "en {0} ano",
          "other": "en {0} anos"
        },
        "past": {
          "one": "hai {0} ano",
          "other": "hai {0} anos"
        }
      },
      "year-narrow": {
        "-1": "o ano pas.",
        "0": "este ano",
        "1": "o próx. ano",
        "future": {
          "one": "en {0} ano",
          "other": "en {0} anos"
        },
        "past": {
          "one": "hai {0} ano",
          "other": "hai {0} anos"
        }
      },
      "year-short": {
        "-1": "o ano pasado",
        "0": "este ano",
        "1": "o próximo ano",
        "future": {
          "one": "en {0} ano",
          "other": "en {0} anos"
        },
        "past": {
          "one": "hai {0} ano",
          "other": "hai {0} anos"
        }
      }
    },
    "locale": "gl"
  });
}